import { goToLogin } from '../../router';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5041';

const leadService = (() => {
  const axios = require('axios');

  const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        goToLogin();
      }
      return Promise.reject(error);
    }
  );

  instance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('jwt-token');
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  const getAllLeads = async () => {
    try {
      const response = await instance.get('/lead');
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const getById = async (id) => {
    try {
      const response = await instance.get(`/lead/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const markAsContacted = async (id) => {
    try {
      const response = await instance.put(`/lead/${id}/contactado`);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const removeLead = async (id) => {
    try {
      const response = await instance.delete(`/lead/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  return {
    getAllLeads,
    getById,
    markAsContacted,
    removeLead,
  };
})();

export default leadService;
